module.exports = {"text":"Verzia {version}"}